import { create } from "zustand";
import type { Me, TokenResponse } from "@/lib/types";

// Access token só em memória (nunca localStorage). O refresh vive num cookie httpOnly.
interface AuthState {
  accessToken: string | null;
  user: Me | null;
  setSession: (data: TokenResponse) => void;
  setUser: (user: Me) => void;
  clear: () => void;
}

export const useAuth = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  setSession: (data) => set({ accessToken: data.access_token, user: data.user }),
  setUser: (user) => set({ user }),
  clear: () => set({ accessToken: null, user: null }),
}));
